import {Link} from 'react-router-dom'

const home = ()=> {



    return(
        <div className="home">
            
            

            <div className="home-text">

            <h1 className="name1">Phoenix Khan</h1>
            <h3 className="home1"> Full Stack Software Engineer</h3>
         
    

            </div>

            <div className='statement'>
          <p>As a software engineer bootcamp graduate, I have dedicated time and resources in creating practical solutions for complicated issues. I am proficient in multiple frontend and backend technologies used in modern industries, capable of deploying user-friendly applications, and quick oto grasp new concepts. My background in the food and retail industry has taught me to collaborate with teams effectively and adapt to new and fast-paced environments. </p>
          </div>

            <div >
                <Link to='/'><button id="side_bar1">Home</button></Link>
                <Link to='/resume'><button id="side_bar2">Resume</button></Link>
                <Link to='/portfolio'><button id="side_bar3">Portfolio</button></Link>
               
            </div>

            <div>
               <p className="wordsofafformation">Create, Innovate, Inspire</p>

            </div>

      


         
        </div>
    )
}

export default home